import { CheckCircle } from "lucide-react";
import { Crown } from "lucide-react";

// ── Voting Host Screen ────────────────────────────────────────────────────────

function ProgressBar({ value, max, color, tv }) {
  const pct = max > 0 ? (value / max) * 100 : 0;
  return (
    <div style={{
      width: "100%", maxWidth: tv ? "500px" : "340px",
      height: tv ? "14px" : "10px",
      background: "#222", borderRadius: "999px",
      overflow: "hidden", margin: "0 auto",
    }}>
      <div style={{
        width: `${pct}%`, height: "100%",
        background: color, borderRadius: "999px",
        transition: "width 0.4s ease",
        boxShadow: `0 0 8px ${color}88`,
      }} />
    </div>
  );
}

export default function VotingHost({ question, voted, players, result, tv }) {
  if (!question) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#FFE000] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full text-center animate-slide-up">
      {/* Question card */}
      <div style={{
        display: "inline-block",
        background: "#1e0845", border: "3px solid #000",
        borderRadius: "1.5rem", boxShadow: "5px 5px 0 #000",
        padding: tv ? "1.75rem 2.75rem" : "0.9rem 1.25rem",
        maxWidth: "91%", marginBottom: "1.75rem",
      }}>
        <h2 className="font-heading text-white" style={{ fontSize: tv ? "2.75rem" : "1.4rem" }}>
          {question}
        </h2>
      </div>

      {!result ? (
        <>
          <div className="font-heading text-[#aaa] mb-2" style={{ fontSize: tv ? "1.35rem" : "0.9rem" }}>
            Проголосовали: {voted.length}/{players.length}
          </div>
          <ProgressBar value={voted.length} max={players.length} color="#FFE000" tv={tv} />
          <div className="flex flex-wrap justify-center gap-3 mt-4">
            {players.map((p, i) => (
              <div key={i}
                className="player-chip"
                style={{
                  backgroundColor: p.color,
                  fontSize: tv ? "1.35rem" : "0.9rem",
                  padding: tv ? "0.5rem 1.3rem" : "0.35rem 0.9rem",
                  opacity: voted.includes(p.name) ? 0.5 : 1,
                  display: "flex", alignItems: "center", gap: "0.3rem",
                }}
              >
                {voted.includes(p.name) && (
                  <CheckCircle style={{ width: "0.9rem", height: "0.9rem" }} />
                )}
                {p.name}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="animate-bounce-in" style={{ maxWidth: tv ? "680px" : "100%", margin: "0 auto" }}>
          {Object.entries(result.vote_counts).sort((a, b) => b[1] - a[1]).map(([name, count], i) => {
            const pl = players.find(p => p.name === name);
            return (
              <div key={name} style={{
                background: "#1e0845", border: "3px solid #000",
                borderRadius: "1rem", boxShadow: "4px 4px 0 #000",
                padding: tv ? "1.1rem 1.4rem" : "0.65rem 1rem",
                display: "flex", alignItems: "center", gap: "0.9rem",
                marginBottom: "0.65rem",
                borderLeft: `6px solid ${pl?.color || "#FF00FF"}`,
              }}>
                {i === 0 && (
                  <Crown style={{
                    color: "#FFE000",
                    width: tv ? "1.75rem" : "1.1rem",
                    height: tv ? "1.75rem" : "1.1rem",
                    flexShrink: 0,
                  }} />
                )}
                <span className="font-heading flex-1 text-left" style={{ fontSize: tv ? "1.75rem" : "1rem" }}>
                  {name}
                </span>
                <span className="font-display" style={{
                  fontSize: tv ? "2.25rem" : "1.35rem",
                  color: pl?.color || "#fff",
                }}>
                  {count}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
